module.exports = __webpack_public_path__ + "static/media/ci.3b1c6d76.png";